// extracted by mini-css-extract-plugin
export default {"loader":"Organisations_loader__dW2BI","l5-0":"Organisations_l5-0__yo2pn","l5-1":"Organisations_l5-1__YsWNo"};